import ExclusiveModal from './exclusive-modal';

export default ExclusiveModal;
